<div class="receipt-image">
  <div app-tosite-kuva class="kuva" [url]="kuvaUrlit[sivuIndeksi]" [expandable]="true" [contain]="true"></div>
</div>

@if (kuvaUrlit.length > 1) {
  <div class="pager">
    <button type="button" class="pg-btn" [disabled]="sivuIndeksi === 0" (click)="edellinenSivu()" [attr.aria-label]="'tositteet.lisaa-tositteita.tosite-kortti.edellinen-sivu-aria' | translate | async">
      <span class="material-symbols-outlined" aria-hidden="true">chevron_left</span>
    </button>
    <span class="pg-label">{{ 'tositteet.lisaa-tositteita.tosite-kortti.sivu-teksti' | translate | async }} {{ sivuIndeksi + 1 }} / {{ kuvaUrlit.length }}</span>
    <button type="button" class="pg-btn" [disabled]="sivuIndeksi >= kuvaUrlit.length - 1" (click)="seuraavaSivu()" [attr.aria-label]="'tositteet.lisaa-tositteita.tosite-kortti.seuraava-sivu-aria' | translate | async">
      <span class="material-symbols-outlined" aria-hidden="true">chevron_right</span>
    </button>
  </div>
}
